const BREADCRUMB_SITEMAP = {
  '/': { langKey: 'home' },
  '/daily_dose': { langKey: 'daily-dose' },
  '/account': { langKey: 'account' },
  '/puzzle-packs': { langKey: 'puzzle-packs' },
  '/stats': { langKey: 'stats' },
  '/information': { langKey: 'information' },
  '/account/badges': { langKey: 'badges' },
  '/account/friends': { langKey: 'friends' },
  '/account/information': { langKey: 'information' },
  '/account/information/terms-and-conditions': { langKey: 'terms-and-conditions' },
  '/account/information/about': { langKey: 'about' },
  '/account/information/privacy': { langKey: 'privacy' },
  '/account/faq': { langKey: 'faq' },
  '/account/game-settings': { langKey: 'game-settings' },
  '/account/notification-settings': { langKey: 'notification-settings' },
  '/account/personal-details': { langKey: 'personal-details' },
  '/account/account-details': { langKey: 'account-details' },
  '/account/account-details/subscription': { langKey: 'subscription' },
  '/account/account-details/payment': { langKey: 'payment' },
  '/account/account-details/invoices': { langKey: 'invoices' },
  '/account/account-details/invoices/invoice': { langKey: 'invoice' },
}

export default BREADCRUMB_SITEMAP
